import type { StyleSystemProps } from '@withjoy/joykit';
import { PRODUCT_GRID_BREAKPOINTS } from '../../../../Catalog.constants';
import { breakpointAliasPx } from '@withjoy/joykit/theme';

export const productOffersGridStyles: StyleSystemProps = {
  marginTop: 8,
  display: 'grid',
  width: {
    _: '100%',
    // the breakpoint is also its own upper width cap
    [PRODUCT_GRID_BREAKPOINTS[3]]: breakpointAliasPx[PRODUCT_GRID_BREAKPOINTS[3]],
  },
  marginX: {
    _: undefined,
    [PRODUCT_GRID_BREAKPOINTS[3]]: 'auto',
  },
  gridColumnGap: {
    _: 3,
    [PRODUCT_GRID_BREAKPOINTS[2]]: 10,
  },
  gridRowGap: {
    _: 5,
    [PRODUCT_GRID_BREAKPOINTS[2]]: 10,
  },
  paddingX: {
    _: 3,
    [PRODUCT_GRID_BREAKPOINTS[2]]: 7,
  },
  gridTemplateColumns: {
    // NOTE: for the future, never render more than 4 columns
    //   this is aligned with the breakpoints in 'ProductGrid.styles'
    [PRODUCT_GRID_BREAKPOINTS[0]]: 'repeat(2, 1fr)',
    [PRODUCT_GRID_BREAKPOINTS[1]]: 'repeat(3, minmax(0, 1fr))',
    [PRODUCT_GRID_BREAKPOINTS[2]]: 'repeat(4, minmax(0, 1fr))',
  },
};
